export default "__VITE_ASSET__BvgltQ$P__"